import { AnyProvider } from "./IntegrationApi";

export class AlchemerApi implements AnyProvider {
  hideNativeControls() {
    const el = document.getElementsByClassName("sg-type-textbox");
    const inputHeader = el[0].getElementsByClassName("sg-question-title") as HTMLCollectionOf<HTMLElement>;
    inputHeader[0].style.display = "none";

    const input = el[0].getElementsByClassName("sg-input-text") as HTMLCollectionOf<HTMLElement>;
    input[0].style.display = "none";

    const alchemerButtons = document.getElementsByClassName("sg-button");

    for (let i = 0; i < alchemerButtons.length; i++) {
      alchemerButtons[i].setAttribute("style", "display: none;");
    }
  }

  showNativeControls() {
    const alchemerButtons = document.getElementsByClassName("sg-button");
    for (let i = 0; i < alchemerButtons.length; i++) {
      alchemerButtons[i].setAttribute("style", "display: inline-block;");
    }
  }

  clickNextButton() {
    // simulate click next button or submit button
    const alchemerSubmitButton = document.getElementsByClassName("sg-submit-button") as HTMLCollectionOf<HTMLElement>;
    if (alchemerSubmitButton.length > 0) {
      alchemerSubmitButton[0].click();
    } else {
      const alchemerNextButton = document.getElementsByClassName("sg-next-button") as HTMLCollectionOf<HTMLElement>;
      if (alchemerNextButton.length > 0) {
        alchemerNextButton[0].click();
      }
    }
  }

  saveResponse(gameId: string, responseId: string) {
    const alchemerInput = document.querySelector(".sg-input-text");
    if (alchemerInput) {
      const inputValue = alchemerInput.getAttribute("value");
      if (inputValue) {
        alchemerInput.setAttribute("value", `${inputValue}, ${gameId}: ${responseId}`);
        return;
      }
      alchemerInput.setAttribute("value", `${gameId}: ${responseId}`);
    }
  }
}
